import { render, staticRenderFns } from "./RegistrationPhoneVerification.vue?vue&type=template&id=e46b68c0&lang=pug&"
import script from "./RegistrationPhoneVerification.vue?vue&type=script&lang=ts&"
export * from "./RegistrationPhoneVerification.vue?vue&type=script&lang=ts&"
import style0 from "./RegistrationPhoneVerification.vue?vue&type=style&index=0&id=e46b68c0&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports